var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoTalentReputation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 98 93",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44.166 93C68.558 93 88.33 73.268 88.33 48.928c0-24.34-19.773-44.073-44.165-44.073S0 24.587 0 48.928C0 73.268 19.774 93 44.166 93Z",
  fill: "#364769"
})), /*#__PURE__*/React.createElement("mask", {
  id: "no-talent-reputation_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 4,
  width: 89,
  height: 89
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.166 93C68.558 93 88.33 73.268 88.33 48.928c0-24.34-19.773-44.073-44.165-44.073S0 24.587 0 48.928C0 73.268 19.774 93 44.166 93Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#no-talent-reputation_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m32.682 71.658 12.442-2.325 13.116 2.552-20.284 6.948-5.274-7.175Z",
  fill: "#FDD355"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.415 58.042-2.832 17.711 15.571.811-2.105-17.968-10.634-.554Z",
  fill: "#BFC6CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.682 71.658S13.595 83.025 12.917 88.396l8.711 38.035h50.623l9.094-41.778C78.566 78.728 58.24 71.885 58.24 71.885L38.3 73.297l-5.614-1.64h-.004Z",
  fill: "#FFBE0D"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.628 113.322-8.71-24.926-8.38 19.993 17.09 18.038v-13.105ZM73.84 116.027l7.505-31.374L92.09 105.54l-9.124 18.796-9.124-8.309Z",
  fill: "#FFBE0D"
}), /*#__PURE__*/React.createElement("path", {
  d: "m89.33 126.427-13.5-15.584a.461.461 0 0 0 .033-.026s-4.035-4.95-4.785-6.444c-.75-1.497-1.041-5.405-1.5-6.82-.46-1.414-2.125-4.78-2.125-4.78s-1.646-4.116-2.26-3.908c-.615.207-.72 3.202 0 4.989l.812 3.66s-7.425-3.413-8.426-2.37c-1.002 1.038-.291 2.578-.291 2.578s-1.418.165-1.626 1.329c-.208 1.164.582 1.787.582 1.787s-1.002.251-1.21 1.082c-.208.831.916 2.285.916 2.285s-1.002.27-1.25 1.329c-.452 1.926 9.547 5.86 9.547 5.86s1.55 1.002 2.885 2.011l8.728 13.019h13.466l.003.003Z",
  fill: "#DBE0E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.238 16.097c-9.26-3.45-28.875-2.955-31.836 30.783l13.482 1.764 27.257.986 10.194-1.593s5.826-31.818-19.1-31.94h.003Z",
  fill: "#1C222E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M68.913 41.676c.063-2.513-.046-5.533-.591-8.603-7.627 2.137-17.078 3.403-27.316 3.403-7.739 0-15.029-.722-21.423-2.002a58.322 58.322 0 0 0-1.46 6.615c7.216-1.223 15.29-1.906 23.809-1.906 9.791 0 18.991.904 26.981 2.49v.003Z",
  fill: "#1C222E"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.238 16.097 6.788-3.324-2.697 4.188-4.09.617v-1.481Z",
  fill: "#1C222E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.28 46.3c-.754 2.707-3.146 4.406-5.347 3.795-2.201-.61-3.374-3.297-2.62-6.005.753-2.707 3.145-4.405 5.346-3.795 2.2.61 3.374 3.298 2.62 6.005ZM34.034 44.097c.75 2.707-.423 5.395-2.624 6.001-2.2.607-4.593-1.094-5.344-3.802-.75-2.707.423-5.395 2.624-6.001 2.201-.607 4.594 1.094 5.344 3.802Z",
  fill: "#BFC6CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.384 30.21c-2.578 5.93-.734 20.95 5.06 27.588 5.412 6.203 8.416 7.192 11.49 7.199 3.221.007 8.46-4.913 10.287-7.75 3.552-5.506 5.921-13.55 4.07-25.37-1.85-11.823-24.245-16.993-30.91-1.663l.003-.003Z",
  fill: "#DBE0E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50.96 23.978 1.51 5.223 10.343.32-9.85-8.818s-12.865-2.387-12.984-2.262c-.12.126-14.14 9.933-14.14 9.933l23.307.725.112-.31 1.702-4.808v-.003ZM39.979 55.622s2.488-1.174 3.44-1.418c.873-.224 2.73-.22 3.602 0 1.087.277 3.94 1.418 3.94 1.418s-2.74 2.579-3.794 2.856c-.906.237-2.856.28-3.748 0-.998-.314-3.44-2.856-3.44-2.856Z",
  fill: "#1C222E"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.362 55.962 2.029-.676h1.897l1.761.676h-5.687Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.361 51.437h5.952l-2.406.801H44.6l-2.238-.801Z",
  fill: "#BFC6CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.272 42.108-1.577.37 1.577.37v-.74Z",
  fill: "#060127"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.162 42.613c0-.023 0-.046-.003-.073-.667-.369-1.44-.712-2.115-.801-1.176-.155-2.092.053-2.772.366a2.068 2.068 0 0 0 .238 1.59l4.216.197c.275-.362.436-.804.436-1.28Z",
  fill: "#060127"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.466 36.476h-9.134l-1.666 1.603v.86l1.93-.755 9.362.755-.492-2.463Z",
  fill: "#1C222E"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41.26 38.883 1.438.136-.525-2.543-.912 2.407ZM47.51 36.664l9.626-.188 1.665 1.603v.86l-1.93-.755-9.761.755.4-2.275Z",
  fill: "#1C222E"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56.102 42.108 1.52.465-1.814.274.294-.739Z",
  fill: "#060127"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.168 42.613c0-.175-.023-.343-.066-.508-.681-.313-1.596-.521-2.773-.366-.674.09-1.447.432-2.115.801 0 .023-.003.047-.003.073 0 .478.165.92.443 1.286l4.203-.195a2.11 2.11 0 0 0 .31-1.091Z",
  fill: "#060127"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "m37.269 38.425-4.441 10.611 3.998 1.247 5.535-8.749-2.94-2.516-2.152-.593ZM53.736 38.425 49.29 49.036l4.002 1.247 5.532-8.749-2.938-2.516-2.151-.593Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.826 50.59c-3.447 0-6.249-2.797-6.249-6.236 0-3.44 2.802-6.236 6.25-6.236 3.446 0 6.248 2.796 6.248 6.236s-2.802 6.236-6.249 6.236Zm0-11.859c-3.106 0-5.634 2.523-5.634 5.623s2.528 5.622 5.634 5.622c3.106 0 5.634-2.522 5.634-5.622s-2.528-5.623-5.634-5.623ZM53.329 50.59c-3.447 0-6.249-2.797-6.249-6.236 0-3.44 2.802-6.236 6.249-6.236 3.447 0 6.249 2.796 6.249 6.236s-2.802 6.236-6.249 6.236Zm0-11.859c-3.106 0-5.634 2.523-5.634 5.623s2.528 5.622 5.634 5.622c3.106 0 5.634-2.522 5.634-5.622s-2.528-5.623-5.634-5.623Z",
  fill: "#364769"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.387 44.044h-4.62v.617h4.62v-.617Z",
  fill: "#364769"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m96.748 15.187 1.157-3.565a1.82 1.82 0 0 0-.661-2.044l-3.04-2.2-1.157-3.564a1.825 1.825 0 0 0-1.745-1.263h-3.754l-3.03-2.2a1.843 1.843 0 0 0-2.165 0l-3.03 2.2h-3.754c-.8 0-1.497.504-1.745 1.263l-1.156 3.564-3.04 2.2a1.82 1.82 0 0 0-.662 2.044l1.157 3.565-1.157 3.565a1.82 1.82 0 0 0 .661 2.044l3.04 2.2 1.157 3.564a1.825 1.825 0 0 0 1.745 1.263h3.754l3.03 2.2c.33.237.708.356 1.084.356.377 0 .754-.119 1.084-.356l3.03-2.2h3.754c.8 0 1.497-.504 1.745-1.263l1.157-3.564 3.04-2.2a1.82 1.82 0 0 0 .66-2.044l-1.156-3.562-.003-.003Zm-7.151-3.014L82.254 19.5a.933.933 0 0 1-1.302 0l-3.671-3.663a.926.926 0 0 1 0-1.303.93.93 0 0 1 1.305 0l3.02 3.024 6.692-6.688a.93.93 0 0 1 1.305 0 .926.926 0 0 1 0 1.303h-.006Z",
  fill: "#00AC6E"
})));
export default SvgNoTalentReputation;